/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { TaskTypeDescription } from './TaskTypeDescription';
import {
    TaskTypeDescriptionFromJSON,
    TaskTypeDescriptionFromJSONTyped,
    TaskTypeDescriptionToJSON,
} from './TaskTypeDescription';

/**
 * 
 * @export
 * @interface GetTaskItemAreaDataTemplateDto
 */
export interface GetTaskItemAreaDataTemplateDto {
    /**
     * 
     * @type {TaskTypeDescription}
     * @memberof GetTaskItemAreaDataTemplateDto
     */
    taskType: TaskTypeDescription;
    /**
     * 
     * @type {string}
     * @memberof GetTaskItemAreaDataTemplateDto
     */
    $type?: GetTaskItemAreaDataTemplateDtoTypeEnum;
}


/**
 * @export
 */
export const GetTaskItemAreaDataTemplateDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoGetTaskItemAreaDataTemplateDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.GetTaskItemAreaDataTemplateDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type GetTaskItemAreaDataTemplateDtoTypeEnum = typeof GetTaskItemAreaDataTemplateDtoTypeEnum[keyof typeof GetTaskItemAreaDataTemplateDtoTypeEnum];



/**
 * Check if a given object implements the GetTaskItemAreaDataTemplateDto interface.
 */
export function instanceOfGetTaskItemAreaDataTemplateDto(value?: unknown): value is GetTaskItemAreaDataTemplateDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(GetTaskItemAreaDataTemplateDtoTypeEnum)[0];
}

export function GetTaskItemAreaDataTemplateDtoFromJSON(json: any): GetTaskItemAreaDataTemplateDto {
    return GetTaskItemAreaDataTemplateDtoFromJSONTyped(json, false);
}

export function GetTaskItemAreaDataTemplateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTaskItemAreaDataTemplateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'taskType': TaskTypeDescriptionFromJSON(json['taskType']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function GetTaskItemAreaDataTemplateDtoToJSON(value?: GetTaskItemAreaDataTemplateDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'taskType': TaskTypeDescriptionToJSON(value['taskType']),
        '$type': value['$type'],
    });
}

